import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { Container } from 'yoso';
import { BaseError } from '~/components/Error/BaseError';
import { LevelUp } from '~/components/LevelUp/LevelUp';
import { LevelUpStep, useLevelUpSearchParams } from '~/components/LevelUp/LevelUp.hooks';
import { Page } from '~/components/Page';
import styles from './LevelUpFormPage.module.scss';

export const LevelUpFormPage = () => {
  const { level } = useLevelUpSearchParams();
  const history = useHistory();
  const onError = useCallback(
    (error: BaseError) => {
      switch (error.message) {
        case 'DISMISSED':
          if ((error as BaseError<{ step?: LevelUpStep }>).payload?.step === 'COMPLETED') {
            history.push('/membership/item/citizen/levelup');
          }
          break;
      }
    },
    [history]
  );
  return (
    <Page className={styles.root} data-event-page_name="Level_up">
      <Container margin="auto">
        <LevelUp level={level} onError={onError} />
      </Container>
    </Page>
  );
};
